function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

// button
(function (window, factory) {
  // universal module definition
  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('./core'), require('fizzy-ui-utils'));
  } else {
    // browser global
    factory(window, window.InfiniteScroll, window.fizzyUIUtils);
  }
})(window, function factory(window, InfiniteScroll, utils) {
  // -------------------------- InfiniteScrollButton -------------------------- //
  var InfiniteScrollButton = /*#__PURE__*/function () {
    function InfiniteScrollButton(element, infScroll) {
      _classCallCheck(this, InfiniteScrollButton);

      this.element = element;
      this.infScroll = infScroll; // events

      this.clickHandler = this.onClick.bind(this);
      this.element.addEventListener('click', this.clickHandler);
      infScroll.on('request', this.disable.bind(this));
      infScroll.on('load', this.enable.bind(this));
      infScroll.on('error', this.hide.bind(this));
      infScroll.on('last', this.hide.bind(this));
    }

    _createClass(InfiniteScrollButton, [{
      key: "onClick",
      value: function onClick(event) {
        event.preventDefault();
        this.infScroll.loadNextPage();
      }
    }, {
      key: "enable",
      value: function enable() {
        this.element.removeAttribute('disabled');
      }
    }, {
      key: "disable",
      value: function disable() {
        this.element.disabled = 'disabled';
      }
    }, {
      key: "hide",
      value: function hide() {
        this.element.style.display = 'none';
      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.element.removeEventListener('click', this.clickHandler);
      }
    }]);

    return InfiniteScrollButton;
  }(); // -------------------------- InfiniteScroll methods -------------------------- //
  // InfiniteScroll.defaults.button = null;


  InfiniteScroll.create.button = function () {
    var buttonElem = utils.getQueryElement(this.options.button);

    if (buttonElem) {
      this.button = new InfiniteScrollButton(buttonElem, this);
    }
  };

  InfiniteScroll.destroy.button = function () {
    if (this.button) this.button.destroy();
  }; // --------------------------  -------------------------- //


  InfiniteScroll.Button = InfiniteScrollButton;
  return InfiniteScroll;
});